import { render, staticRenderFns } from "./LogTrans.vue?vue&type=template&id=0ed5f040&scoped=true&"
import script from "./LogTrans.vue?vue&type=script&lang=js&"
export * from "./LogTrans.vue?vue&type=script&lang=js&"
import style0 from "./LogTrans.vue?vue&type=style&index=0&id=0ed5f040&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5f040",
  null
  
)

export default component.exports